import React from "react";
import styles from "./BetTableCard32.module.css";

export default function BetTableCard32({ data, onBetClick, exposures = {}, myBets = [] }) {
  // Helper function to get exposure value - handle various key formats
  const getExposure = (playerName) => {
    if (!exposures || Object.keys(exposures).length === 0) return null;
    
    const keys = [
      playerName,
      playerName?.toLowerCase(),
      playerName?.trim(),
      playerName?.replace(/\s+/g, ' ').trim(),
    ];

    for (const key of keys) {
      if (key && exposures[key] !== undefined) {
        return exposures[key];
      }
    }
    return null;
  };

  // Format exposure value
  const formatExposure = (value) => {
    if (value === null || value === undefined || value === 0) return "0";
    // For large numbers, show without decimals
    if (Math.abs(value) >= 1000) {
      return value < 0 ? value.toFixed(0) : value.toFixed(0);
    }
    return value < 0 ? value.toFixed(2) : value.toFixed(2);
  };

  // Check if bet is suspended
  const isSuspended = (betData) => {
    return betData?.gstatus?.toUpperCase() === "SUSPENDED" || !betData || betData.b === 0 || betData.b === null || betData.b === undefined;
  };

  // Get first player bet data for min/max (assuming all have same limits)
  const firstPlayer = data?.[0];
  const firstPlayerData = Array.isArray(firstPlayer) ? (firstPlayer?.[0] || {}) : (firstPlayer || {});

  const formatLimit = (value) => {
    if (value >= 1000) {
      return `${(value / 1000).toFixed(0)}K`;
    }
    return value?.toFixed(1) || "100.0";
  };

  // Only show header if data exists
  const shouldShowHeader = data && Array.isArray(data) && data.length > 0;

  // Split data into two groups: Player 8-9 (left) and Player 10-11 (right)
  const leftTableData = data.slice(0, 2); // First 2 players (Player 8, 9)
  const rightTableData = data.slice(2, 4); // Next 2 players (Player 10, 11)

  // Render a single table
  const renderTable = (tableData, startIndex) => {
    return (
      <div className={`table-responsive ${styles.betTableCard32Wrapper}`} style={{ width: '50%' }}>
        <table className={`table table-bordered ${styles.betTableCard32}`}>
          {shouldShowHeader && (
            <thead>
              <tr>
                <th style={{ backgroundColor: '#333d79ff', background: '#333d79ff', color: 'white', padding: '2px' }} className="box-4 min-max">
                  <div className="d-block">
                    <div style={{ fontSize: '10px', display: 'flex', color: 'white' }}> Min: <div style={{ fontSize: '10px', color: 'white' }}>{formatLimit(firstPlayerData?.min || 100)}</div></div>
                    <div style={{ fontSize: '10px', display: 'flex', color: 'white' }}> Max: <div style={{ fontSize: '10px', color: 'white' }}>{formatLimit(firstPlayerData?.max || 300000)}</div></div>
                  </div>
                </th>
                <th style={{ backgroundColor: '#72bbef', background: '#72bbef', padding: '2px', color: '#000' }} className="text-center box-3 Back">BACK</th>
                <th style={{ backgroundColor: '#faa9ba', background: '#faa9ba', padding: '2px', color: '#000' }} className="text-center box-3 lay">LAY</th>
              </tr>
            </thead>
          )}
          <tbody>
            {tableData.map((player, localIndex) => {
              const index = startIndex + localIndex;
              // Handle both array structure [playerData] and direct playerData
              const playerData = Array.isArray(player) ? (player?.[0] || {}) : (player || {});
              const backVal = playerData?.b || "0";
              const layVal = playerData?.l || "0";
              const nat = playerData?.nat;
              const playerName = nat?.trim() ? nat : `Player ${index + 8}`;
              const isSuspendedPlayer = isSuspended(playerData);

              // Get exposure values - always show exposure value (even if 0)
              const exposure = getExposure(playerName);

              return (
                <tr key={playerName + index} data-title={playerData?.gstatus || "OPEN"} className={isSuspendedPlayer ? styles.suspendedRow : ""}>
                  <td className="box-4 player-name" style={{ backgroundColor: '#333d79ff', background: '#333d79ff', color: 'white', padding: '2px' }}>
                    <div style={{ color: 'white', fontSize: '12px', marginLeft: '10px' }}><b>{playerName}</b></div>
                    <span className="d-block ubook" style={{ color: exposure !== null && exposure > 0 ? 'red' : 'white', fontSize: '10px', marginLeft: '10px' }}>
                      {formatExposure(exposure)}
                    </span>
                  </td>

                  {/* Back */}
                  <td
                    className="back text-center box-3 back"
                    onClick={() => !isSuspendedPlayer && onBetClick && onBetClick(backVal, playerName, "back", playerData)}
                    style={{
                      cursor: isSuspendedPlayer ? 'not-allowed' : 'pointer',
                      backgroundColor: '#72bbef',
                      background: '#72bbef',
                      position: 'relative',
                      padding: '2px'
                    }}
                  >
                    <div className="position-relative d-flex flex-column align-items-center justify-content-center h-100" style={{ minHeight: '40px' }}>
                      <span className="d-block text-bold odds">{backVal}</span>
                      <span className="d-block" style={{ fontSize: '10px', color: 'black' }}>{formatExposure(exposure)}</span>
                    </div>
                  </td>

                  {/* Lay */}
                  <td
                    className="back text-center box-3 lay"
                    onClick={() => !isSuspendedPlayer && onBetClick && onBetClick(layVal, playerName, "lay", playerData)}
                    style={{
                      cursor: isSuspendedPlayer ? 'not-allowed' : 'pointer',
                      backgroundColor: '#faa9ba',
                      background: '#faa9ba',
                      position: 'relative',
                      padding: '2px'
                    }}
                  >
                    <div className="position-relative d-flex flex-column align-items-center justify-content-center h-100" style={{ minHeight: '40px' }}>
                      <span className="d-block text-bold odds">{layVal}</span>
                      <span className="d-block" style={{ fontSize: '10px', color: 'black' }}>{formatExposure(exposure)}</span>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div style={{ display: 'flex', gap: '10px', width: '100%' }}>
      {renderTable(leftTableData, 0)}
      {renderTable(rightTableData, 2)}
    </div>
  );
}

